import './page-footer.css';

import { 
    Icon,
} from '../components';

export function PageFooter({children}) {
    return (
        <footer className="page-footer">
            <Icon name="footer" class="page-footer-background" />
            <section className="page-footer-content">
                {children}
            </section>
        </footer>
    );
}